import React from "react";
import { Navigate } from "react-router-dom";
import { checkForSuperAdmin, isAuthenticated } from "./auth";

const SuperAdminRoute = ({ children }: any) => {
  return isAuthenticated() ? (
    !checkForSuperAdmin(isAuthenticated()?.user) ? (
      <Navigate to="/" />
    ) : (
      children
    )
  ) : (
    <Navigate to="/login" />
  );
};

export default SuperAdminRoute;
